import { render, staticRenderFns } from "./page0.vue?vue&type=template&id=2e1b378a&scoped=true&"
import script from "./page0.vue?vue&type=script&lang=ts&"
export * from "./page0.vue?vue&type=script&lang=ts&"
import style0 from "./page0.vue?vue&type=style&index=0&id=2e1b378a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b378a",
  null
  
)

export default component.exports